// Must run after nuxt:revive-payload:client (-30) and before nuxt:router (-20).
// Prerendered payloads store `path` without the visitor's query string, and the
// router replaces the URL with it on hydration, dropping UTMs.
export default defineNuxtPlugin({
  name: 'preserve-query-on-hydration',
  order: -25,
  setup(nuxtApp) {
    if (window.location.search) {
      delete nuxtApp.payload.path;
    }
  },
});
